import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { I18NextModule } from 'angular-i18next';

export interface CampaignInfoDialogData {
  info: string;
}

@Component({
  standalone: true,
  selector: 'app-campaign-info-dialog',
  templateUrl: './campaign-info-dialog.component.html',
  styleUrls: ['./campaign-info-dialog.component.scss'],
  imports: [CommonModule, I18NextModule, MatDialogModule]
})
export class CampaignInfoDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<CampaignInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CampaignInfoDialogData
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
